/**
 * The demo project's one plot: a closed rectangle. The project's area (`plotAreaM2`, which the header, the cards and the
 * facts show) and the site record's boundary (what the Site page draws and measures) both come from these two numbers,
 * so every screen states the same shape and the same area.
 */
export const DEMO_PLOT = {
  projectId: "bodakdev-residence",
  widthM: 34,
  depthM: 30.5,
} as const;

export const DEMO_PLOT_AREA_M2 = DEMO_PLOT.widthM * DEMO_PLOT.depthM;
